import { CSSObject } from "@emotion/react";
import {
  typographyStyles,
  type CheckboxStyleOverrides,
  type AngelouCSS,
} from "@newsela/angelou";

const { textMObj } = typographyStyles;

export const viewAllButtonCss = {
  root: {
    padding: "4px 8px",
    borderRadius: "6px",
    marginTop: "8px",
  },
};

export const conceptsContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const listContainerCss: CSSObject = {
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

export const listItemCss: CSSObject = {
  listStyle: "none",

  "> div": {
    display: "flex",
    alignItems: "center",
  },
};

export const checkboxCss: CheckboxStyleOverrides<AngelouCSS> = {
  root: {
    padding: 0,
  },

  labelText: {
    ...textMObj,
    marginTop: "-3px",
  },
};
